export const NID_DETAILS_LOADING = "NID_DETAILS_LOADING";
export const NID_DETAILS_SUCCESS = "NID_DETAILS_SUCCESS";
export const NID_DETAILS_FAILED = "NID_DETAILS_FAILED";

export const UPLOAD_FILE_MULTIPART_LOADING_NID =
  "UPLOAD_FILE_MULTIPART_LOADING_NID";
export const UPLOAD_FILE_MULTIPART_SUCCESS_NID =
  "UPLOAD_FILE_MULTIPART_SUCCESS_NID";
export const UPLOAD_FILE_MULTIPART_FAILED_NID =
  "UPLOAD_FILE_MULTIPART_FAILED_NID";

export const SAVE_NID_DETAILS_LOADING = "SAVE_NID_DETAILS_LOADING";
export const SAVE_NID_DETAILS_SUCCESS = "SAVE_NID_DETAILS_SUCCESS";
export const SAVE_NID_DETAILS_FAILED = "SAVE_NID_DETAILS_FAILED";

export const DELETE_FILE_LOADING_NID = "DELETE_FILE_LOADING_NID";
export const DELETE_FILE_SUCCESS_NID = "DELETE_FILE_SUCCESS_NID";
export const DELETE_FILE_FAILED_NID = "DELETE_FILE_FAILED_NID";


export const NID_DETAILS_WITHOCR_LOADING = "NID_DETAILS_WITHOCR_LOADING";
export const NID_DETAILS_WITHOCR_SUCCESS = "NID_DETAILS_WITHOCR_SUCCESS";
export const NID_DETAILS_WITHOCR_FAILED = "NID_DETAILS_WITHOCR_FAILED";

export const VERIFY_PROFILE_DATA_LOADING = "VERIFY_PROFILE_DATA_LOADING";
export const VERIFY_PROFILE_DATA_SUCCESS = "VERIFY_PROFILE_DATA_SUCCESS";
export const VERIFY_PROFILE_DATA_FAILED = "VERIFY_PROFILE_DATA_FAILED";

export const CAPTCHA_DATA_LOADING = "CAPTCHA_DATA_LOADING";
export const CAPTCHA_DATA_SUCCESS = "CAPTCHA_DATA_SUCCESS";
export const CAPTCHA_DATA_FAILED = "CAPTCHA_DATA_FAILED";

export const SEND_OTP_LOADING = "SEND_OTP_LOADING";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAILED = "SEND_OTP_FAILED";

export const VERIFY_OTP_LOADING = "VERIFY_OTP_LOADING";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILED = "VERIFY_OTP_FAILED";

export const SAVE_PAN_LOADING = "SAVE_PAN_LOADING";
export const SAVE_PAN_SUCCESS = "SAVE_PAN_SUCCESS";
export const SAVE_PAN_FAILED = "SAVE_PAN_FAILED";

export const NID_OCR_FLAG_LOADING = "NID_OCR_FLAG_LOADING";
export const NID_OCR_FLAG_SUCCESS = "NID_OCR_FLAG_SUCCESS";
export const NID_OCR_FLAG_FAILED = "NID_OCR_FLAG_FAILED";    